// Length Validators
import {ValidatorResult} from "../types";
import {BaseValidator} from "./validator.interface";

export class MinLengthValidator extends BaseValidator {
    private readonly min: number;

    constructor(min: number, message?: string) {
        super(message || "minLength", {min});
        this.min = min;
    }

    validate(value: string): ValidatorResult {
        if (!value || value.length === 0) {
            return this.success(); // Empty value is valid
        }

        return value.length >= this.min ? this.success() : this.fail();
    }
}

export class MaxLengthValidator extends BaseValidator {
    private readonly max: number;

    constructor(max: number, message?: string) {
        super(message || "maxLength", {max});
        this.max = max;
    }

    validate(value: string): ValidatorResult {
        if (!value || value.length === 0) {
            return this.success(); // Empty value is valid
        }

        return value.length <= this.max ? this.success() : this.fail();
    }
}

export class RangeLengthValidator extends BaseValidator {
    private readonly min: number;
    private readonly max: number;

    constructor(min: number, max: number, message?: string) {
        super(message || "lengthRange", {min, max});
        this.min = min;
        this.max = max;
    }

    validate(value: string): ValidatorResult {
        const length = value.length;

        if (length === 0) {
            return this.success(); // Empty value is valid
        }

        return length >= this.min && length <= this.max ? this.success() : this.fail();
    }
}
